import React, { useState, useEffect } from "react";
import { Select, MenuItem, FormControl, InputLabel, Box } from "@mui/material";
import api from "core/interceptors/api";
import { disableBackNavigation } from "core/utils/storage";
import logo from "../../assets/images/logo.png";
import MDTypography from "components/MDTypography";

function DropDown({ onSelectOption }) {
  const [loading, setLoading] = useState(true);
  const [vendors, setVendors] = useState([]);
  const [selectedOption, setSelectedOption] = useState("AllVendors"); // Default value set to "AllVendors"

  const handleChange = (event) => {
    const value = event.target.value;
    setSelectedOption(value);
    console.log(selectedOption);
    onSelectOption(value); // Pass the selected option to the parent
  };

  const fetchVendors = async () => {
    try {
      const res = await api.get("/vendor_register/fetch");
      setVendors(res.data || []);
    } catch (error) {
      console.error("Error fetching vendors:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    disableBackNavigation();
    <Box display="flex" alignItems="center" gap={1} mb={2}>
      <img
        src={logo}
        alt="Brand Logo"
        style={{ height: 40, width: 40, objectFit: "contain" }}
      />
      <MDTypography variant="h6" fontWeight="bold">
        {document.title}
      </MDTypography>
    </Box>
    fetchVendors();
    onSelectOption("AllVendors"); // Inform the parent about the default value
  }, []);

  return (
    <FormControl fullWidth margin="normal">
      <InputLabel>Select Vendor</InputLabel>
      <Select
        label="Select Vendor"
        name="vendor-select"
        value={selectedOption}
        onChange={handleChange}
        sx={{
          height: "45px",
          width: "250px",
        }}
      >
        <MenuItem value="AllVendors">All Vendor</MenuItem>
        {vendors.map((vendor) => (
          <MenuItem key={vendor.id} value={vendor.vendor_email}>
            {vendor.vendor_name}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}

export default DropDown;
